<div #calendarContainer class="h-full flex flex-col">
  <div class="w-[1010px] v4-filter-list py-[30px] justify-between">
    <div class="v4-filter-item">
      <nz-select [(ngModel)]="currentMonth" (ngModelChange)="onMonthChange($event)">
        <nz-option *ngFor="let month of listOfMonthOption" [nzLabel]="month" [nzValue]="month"></nz-option>
      </nz-select>
    </div>

    <div class="v4-filter-item">
      <button nz-button nz-dropdown [nzDropdownMenu]="menu" nzTrigger="click">
        {{ "word.view" | translate }}
        <!-- View -->
        <span nz-icon nzType="down"></span>
      </button>

      <nz-dropdown-menu #menu="nzDropdownMenu">
        <ul nz-menu>
          <li nz-menu-item (click)="onToggleView('price')">
            <v4-selectable-menu-item [checked]="showLeadChannel">
              {{ "single_house_status_calendar_html_opt_view_show_price" | translate }}
              <!-- Show price of the lead channel -->
            </v4-selectable-menu-item>
          </li>
          <li nz-menu-item (click)="onToggleView('rule')">
            <v4-selectable-menu-item [checked]="showBookingRulesOfLC">
              {{ "single_house_status_calendar_html_opt_view_show_rules" | translate }}
              <!-- Show booking rules of the lead channel -->
            </v4-selectable-menu-item>
          </li>
        </ul>
      </nz-dropdown-menu>
    </div>
  </div>

  <div class="flex flex-row flex-wrap flex-1 overflow-y-auto" #scrollContainer>
    <div
      class="mr-[30px] mb-[30px] border border-solid border-[#e2e5e9] rounded-[12px] overflow-hidden calendar-item"
      *ngFor="let month of listOfMonthOption; let index = index">
      <div class="calendar-skeleton" [attr.data-month]="month">
        <div
          [ngClass]="{
            'w-[490px] h-[500px] p-[30px]': !inviewedMonth.has(month),
            'w-0 h-0': inviewedMonth.has(month)
          }">
          <nz-skeleton class="mx-auto" [nzActive]="true" [nzParagraph]="{ rows: 12 }"></nz-skeleton>
        </div>

        <ng-container *ngIf="inviewedMonth.has(month)">
          <div class="leading-[42px] text-center text-[16px] text-[#272b30] border-b border-solid border-[#e2e5e9]">
            {{ month | dateformat: ["YM"] }}
          </div>
          <host-month-calendar-v2
            [house]="houseInfo"
            [showLeadPrice]="showLeadChannel"
            [showLeadRules]="showBookingRulesOfLC"
            [currentDate]="month"
            [calendarMap]="calendarMap"
            [hourReservationMap]="hourReservationMap"
            [taskMap]="taskMap"
            [channelColorMap]="channelColorMap"
            [reservationStyle]="reservationStyle"
            [selectedReservationCode]="selectedReservation"
            [listOfSelectedDates]="listOfSelectedDates"
            [selectStatus]="selectStatus"
            (onSelectCell)="onSelectCell($event)"
            (onSelectResv)="onSelectResv($event)"
            (onCreateHourResv)="onCreateHourResv($event)"
            (onClickChangeAvailable)="onClickChangeAvailable($event)"
            (onClickChangeTab)="onClickChangeTab($event)"
            (onClickTask)="onClickTask($event)"
            (onClickCreateTask)="onClickCreateTask($event)"
            (onClickEditNote)="onClickEditNote($event)"
            (onClickExtendStay)="onClickExtendStay($event)"></host-month-calendar-v2>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<!-- <host-operate-sidebar
  *ngIf="selectStatus?.status === 'done' || sidebarType === 'hour-reservation'"
  [type]="sidebarType"
></host-operate-sidebar> -->

<!-- <host-order-detail-sidebar></host-order-detail-sidebar> -->
